import { motion } from "framer-motion";
import { XIcon, CheckIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
const before = ["Dudas al aprobar un ClinCheck.", "Refinamientos que podrían haberse evitado.", "Incertidumbre sobre cuándo realizar IPR o expansión.", "Attachments seleccionados por intuición.", "Casos que terminan siendo más largos de lo esperado.", "Dependencia total del software para decidir."];
const after = ["Sigues un protocolo claro antes de aprobar cada caso.", "Tomas decisiones clínicas con mayor seguridad.", "Reduces errores que afectan la predictibilidad.", "Comprendes cuándo utilizar cada biomecánica.", "Planificas tratamientos más eficientes.", "Control total desde el diagnóstico hasta la finalización."];
export function BeforeAfter() {
  return <section className="w-full bg-slate-50 py-14 sm:py-20" data-id="element-26" data-mp="2vsezqoz6lfa4">
      <div className="mx-auto max-w-lg px-5 sm:max-w-3xl lg:max-w-5xl" data-id="element-27" data-mp="30pxcyrk8egnx">
        <SectionHeading eyebrow="El cambio" title="De la incertidumbre clínica a la confianza para planificar cualquier caso" subtitle="Miles de decisiones clínicas resumidas en un Sistema Visual de Decisión que te guía paso a paso." data-id="element-28" data-mp="30s9oalvhhss0" />

        <div className="mt-9 grid gap-4 lg:grid-cols-2" data-id="element-29" data-mp="1727yvrdi77pi">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} className="rounded-2xl border border-red-100 bg-white p-5 shadow-sm sm:p-6" data-id="element-30" data-mp="12355532z4nwu">
            <h3 className="mb-4 flex items-center gap-2 font-head text-lg font-800 text-slate-700" data-id="element-31" data-mp="o3lzqi1jrqo8">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-red-100 text-red-500" data-id="element-32" data-mp="jcned41pc2e4">
                <XIcon className="h-4 w-4" strokeWidth={3} data-id="element-33" data-mp="3rs74vvazn6ph" />
              </span>
              Antes
            </h3>
            <ul className="space-y-3" data-id="element-34" data-mp="3mt2vb3k5j6ym">
              {before.map(t => <li key={t} className="flex items-start gap-3 text-sm text-slate-600 sm:text-[15px]" data-id="element-35" data-mp="1qr963jau9qdl">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" strokeWidth={3} data-id="element-36" data-mp="1vp10ql2vbqlh" />
                  <span data-id="element-37" data-mp="20g0y1rfwgaoi">{t}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} className="rounded-2xl border-2 border-[#1e88e5]/30 bg-[#0f2547] p-5 shadow-lg sm:p-6" data-id="element-38" data-mp="24ie1g976bwi4">
            <h3 className="mb-4 flex items-center gap-2 font-head text-lg font-800 text-white" data-id="element-39" data-mp="1grs5vhecw4p0">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#2196f3] text-white" data-id="element-40" data-mp="1lsfuxxj0ybgl">
                <CheckIcon className="h-4 w-4" strokeWidth={3} data-id="element-41" data-mp="2s76y67vme8ds" />
              </span>
              Con el Sistema Maestro
            </h3>
            <ul className="space-y-3" data-id="element-42" data-mp="37aqjunwwlzqm">
              {after.map(t => <li key={t} className="flex items-start gap-3 text-sm text-white/85 sm:text-[15px]" data-id="element-43" data-mp="37cuml2j2gspb">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#2196f3]" strokeWidth={3} data-id="element-44" data-mp="32dqe6e3yuz01" />
                  <span data-id="element-45" data-mp="2xiu8wc9pyf4z">{t}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <p className="mt-8 text-center font-head text-lg font-800 text-[#0f2547] sm:text-xl" data-id="element-46" data-mp="2ok8w6xqxhuc4">
          Tú mereces planificar con la confianza de un especialista.
        </p>
      </div>
    </section>;
}